import React from 'react';

const HiddenInput = ({ input, type, name, id }) => (
  <div>
    <input style={{ display: 'none' }} id={id} name={name} {...input} type={type} className="form-control" />
  </div>
);

export default HiddenInput;
